// extracted by mini-css-extract-plugin
module.exports = {"report_item":"styles_report_item__1uYkJ","report_item_text":"styles_report_item_text__2tqep","report_item_data":"styles_report_item_data__3twIw","history":"styles_history__2YjzS"};